module.exports = __webpack_public_path__ + "assets/img/news (49).364ec4b6.png";